import _ from 'lodash';

import OhsUserLocalServices from 'user/OhsUserLocalServices';

import { TierType } from '../OhsObject';
import { OhsTier } from './OhsTier';

const getTierService = (tier: OhsTier): OhsTier => {
  const recordTier: OhsTier = { ...tier };
  const user = OhsUserLocalServices.getLocalOhsUser();

  if (user?.tierNum === 3) {
    if (recordTier.type === TierType.T3) {
      recordTier.name = user?.org?.name || '';
    } else {
      recordTier.name = _.find(user?.configs.admin2?.LOWER_TIER_ACCESS, {
        _id: recordTier._id,
      })?.name!;
    }
  } else if (user?.tierNum === 4) {
    if (recordTier.type === TierType.T4) {
      recordTier.name = user?.workplace?.name || '';
    } else {
      recordTier.name = _.find(user?.configs.admin2?.LOWER_TIER_ACCESS, {
        _id: recordTier._id,
      })?.name!;
    }
  } else if (user?.tierNum === 5) {
    if (recordTier._id === user.workplace?._id) {
      recordTier.name = user.workplace?.name || '';
    }
  }
  return recordTier;
};

// using alais for now, so we don't have to refactor all the old imports
export { getTierService as setTierName };

export default getTierService;
